import { Fab } from '@mui/material';
import React from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';

function BackButton() {
  const navigate = useNavigate();

  return (
    <Fab
      onClick={() => {
        navigate(-1);
      }}
      sx={{
        backgroundColor: 'white',
      }}>
      <ArrowBackIosNewIcon />
    </Fab>
  );
}

export default BackButton;
